import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSalesDocumentStatus as UpdateSalesDocumentStatusMutation,
    UpdateSalesDocumentStatusVariables as UpdateSalesDocumentStatusVariables,
    SalesDocumentUpdateStatusInput,
} from 'nutshell-graphql-types';

import UPDATE_SALES_DOCUMENT_STATUS from '../mutations/sales-document-update-status.graphql';

export const useUpdateSalesDocumentStatus = (): {
    updateSalesDocumentStatus: (arg1: SalesDocumentUpdateStatusInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateSalesDocumentStatus, {loading, error}] = useMutation<
        UpdateSalesDocumentStatusMutation,
        UpdateSalesDocumentStatusVariables
    >(UPDATE_SALES_DOCUMENT_STATUS);

    return {
        updateSalesDocumentStatus: (input: SalesDocumentUpdateStatusInput) =>
            updateSalesDocumentStatus({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
